import { usePromotedEvents } from '@eventbrite/ads';
import {
    EventSearchInterfaceName,
    transformToPromotedEventSearchApiPayload,
} from '../../../../api/searchAllEvents';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { useBaseSearchQuery } from '../../hooks/queries/events';

export function useCategoryBrowsePromotedEvents({
    search = {},
    bucketName,
    enabled,
    slots = 1,
}: {
    search?: OrganicEventSearchFiltersApiPayload;
    bucketName: EventSearchInterfaceName;
    enabled: boolean;
    slots: number;
}) {
    const overloadedQuery = useBaseSearchQuery(search);
    const apiPayload = transformToPromotedEventSearchApiPayload({
        ...overloadedQuery,
        page: 1,
    });

    const {
        data: promotedEvents,
        isFetching: arePromotedEventsLoading,
        removeEvent,
    } = usePromotedEvents({
        slots,
        interfaceName: bucketName,
        search: apiPayload,
        enabled,
    });
    return {
        promotedEvents,
        arePromotedEventsLoading,
        removeEvent,
    };
}
